module.exports = __webpack_public_path__ + "svg/illustration-corporate-kit.5ca4c6b.svg";